export const VALIDATE_EMAIL = 'VALIDATE_EMAIL';
export const VERIFY_EMAIL_API = 'VERIFY_EMAIL_API';
export const VERIFY_EMAIL_MANUAL = 'VERIFY_EMAIL_MANUAL';
export const UPDATE_ABOUT_YOURSELF_FORM = 'UPDATE_ABOUT_YOURSELF_FORM';

export const VALIDATE_MOBILE = 'VALIDATE_MOBILE';
export const VALIDATE_MOBILE_NO = 'VALIDATE_MOBILE_NO';

export const UPDATE_SERVICE_ADDRESS = 'UPDATE_SERVICE_ADDRESS';
export const UPDATE_ADDRESS_TYPEAHEAD = 'UPDATE_ADDRESS_TYPEAHEAD';
export const ADDRESS_TYPEAHEAD_RESET = 'ADDRESS_TYPEAHEAD_RESET';

export const UPDATE_SERVICE_UNITS = 'UPDATE_SERVICE_UNITS';
export const UPDATE_UNITS_TYPEAHEAD = 'UPDATE_UNITS_TYPEAHEAD';
